// Hizmet / paket / tahsilat ekranlarının ortak parçaları: drawer kabuğu, alan
// stilleri, durum etiketleri. Kurallar: docs/design-principles.md §7–§8.
import React from "react";
import { Box, Drawer } from "@mui/material";
import { DrawerHeader, DrawerFooter, FormTextField } from "../../atoms";
import { tileInputProps } from "../../molecules/InfoTile";
import { COLORS } from "../../../styles/uiConstants";

export const PACKAGE_STATUS = {
  active: { label: "Aktif", tone: "success" },
  completed: { label: "Tamamlandı", tone: "neutral" },
  expired: { label: "Süresi doldu", tone: "warning" },
  cancelled: { label: "İptal", tone: "error" },
};

export const USAGE_SOURCE_LABELS = {
  appointment: "Randevu",
  session: "Seans",
  manual: "Elle düşüldü",
};

export const dateTr = (d) =>
  d ? new Date(d).toLocaleDateString("tr-TR", { day: "2-digit", month: "short", year: "numeric" }) : "—";

export const dateTimeTr = (d) =>
  d
    ? new Date(d).toLocaleString("tr-TR", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      })
    : "—";

export const todayYmd = () => {
  const d = new Date();
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
};

/** Drawer içi alan ızgarası (design-principles §7: rowGap 2.5, columnGap 2). */
export const fieldGridSx = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
  rowGap: 2.5,
  columnGap: 2,
};

/** Drawer standart metin alanı (kutusuz, alt çizgili). */
export function DrawerInput({ palette, inputProps, ...rest }) {
  return (
    <FormTextField
      palette={palette}
      variant="standard"
      size="small"
      fullWidth
      InputProps={tileInputProps(true)}
      inputProps={inputProps}
      {...rest}
    />
  );
}

/**
 * Sağdan açılan form drawer'ı: DrawerHeader + kaydırılan beyaz gövde + DrawerFooter.
 * `onSubmit` verilmezse yalnız "Kapat" görünür.
 */
export function FormDrawer({
  open,
  onClose,
  icon,
  title,
  subtitle,
  width = 480,
  children,
  onSubmit,
  submitLabel = "Kaydet",
  submitColor,
  loading,
  disabled,
  startIcon,
  cancelLabel = "Vazgeç",
}) {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={loading ? undefined : onClose}
      PaperProps={{
        sx: {
          width: { xs: "100%", sm: width },
          bgcolor: COLORS.white,
          boxShadow: "0 8px 32px 0 rgba(60,72,100,0.15)",
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <DrawerHeader icon={icon} title={title} subtitle={subtitle} onClose={onClose} />
      <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto", px: 3, py: 2.5 }}>{children}</Box>
      <DrawerFooter
        onCancel={onClose}
        cancelLabel={onSubmit ? cancelLabel : "Kapat"}
        onSubmit={onSubmit}
        submitLabel={submitLabel}
        submitColor={submitColor}
        loading={loading}
        disabled={disabled}
        startIcon={startIcon}
        fullWidth
      />
    </Drawer>
  );
}
